module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛区:",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formData.saiqu.name) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位:",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formData.baoming.danwei) + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "队伍名称:",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formData.baoming.mingcheng) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目:",
      "prop": "name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formData.subject_name) + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频",
      "prop": "grade"
    }
  }, [_c('VideoUploader', {
    attrs: {
      "fileList": _vm.formData.video,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("请上传一段视频")])], 1)], 1), _vm._v(" "), (_vm.formData.subject_name.indexOf('活力大课间啦啦操展示') >= 0) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运动员人数"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "auto !important"
    },
    attrs: {
      "min": 0,
      "max": 3000
    },
    model: {
      value: (_vm.formData.yundongyuan_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "yundongyuan_count", $$v)
      },
      expression: "formData.yundongyuan_count"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 如果不上传运动员信息，请填写运动员人数\n          ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参赛运动员"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("先下载导入模版")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "accept": ".xls,.xlsx",
      "after-read": _vm.readFile
    }
  }, [_c('el-button', {
    attrs: {
      "size": "normal"
    }
  }, [_vm._v("再批量导入\n                    ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("运动员姓名将显示在比赛证书上，"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("请谨慎填写"), _c('br'), _vm._v("如果不填写运动员，后期将无法导出证书。")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.yundongyuan.length),
      expression: "formData.yundongyuan.length"
    }]
  }, _vm._l((_vm.formData.yundongyuan), function(yundongyuan, index) {
    return _c('div', {
      key: index,
      staticClass: "memberLi"
    }, [_vm._v("\n                  运动员" + _vm._s(index + 1) + "\n                  "), _c('el-tag', {
      key: index,
      attrs: {
        "round": "",
        "closable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.yundongyuan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(yundongyuan.name) + "  \n                  ")])], 1)
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")]), _vm._v(" "), (false) ? _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c0e6880","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormUploadVideo.vue
// module id = 1399
// module chunks = 0